import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarehouse, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { renderPrice, getCurrencyValue } from '../../libs/cartLib';

export function renderVenueBadge(ticket) {
  if (ticket.show_type === 'VENUE') {
    return (
      <span className="cart-badge cart-badge-venue">
        <FontAwesomeIcon icon={faWarehouse} style={{marginRight: 4}} />
        {ticket.venue}
      </span>
    );
  } else {
    return (
      <span className="cart-badge cart-badge-venue">
        <FontAwesomeIcon icon={faGlobe} style={{marginRight: 4}} />
        Online
      </span>
    );
  }
}

export function renderSectionBadge(ticket) {
  const section = ticket.location && ticket.location.section ? ticket.location.section : (ticket.section || '');
  const door = ticket.location && ticket.location.door ? ticket.location.door : (ticket.door || '');
  let label = '';
  if (section && door) {
    label = `Sección: ${section} / Puerta: ${door}`;
  } else if (section) {
    label = `Sección: ${section}`;
  } else if (door) {
    label = `Puerta: ${door}`;
  }
  return label ? (
    <span className="cart-badge cart-badge-section">
      {label}
    </span>
  ) : null;
}

export function renderItemPriceDetail(cart, ticket) {
  const itemPrice = <>{ticket.quantity} x <span className="cart-item-price-bold">{renderPrice(cart, getCurrencyValue(cart, ticket, 'price'))}</span></>;
  const itemDiscountPrice = <>{ticket.quantity} x <span className="cart-item-price-bold">{renderPrice(cart, getCurrencyValue(cart, ticket, 'discount_price'))}</span></>;
  const feeInfo = ticket.fee && !ticket.fee_included && ticket.fee > 0 ? (
    <div className="cart-item-fee">
      Servicio: {ticket.quantity} x +{renderPrice(cart, getCurrencyValue(cart, ticket, 'fee'))}
    </div>
  ) : null;
  if (ticket.discount_price > 0) {
    return <><span style={{textDecoration:'line-through'}}>{itemPrice}</span><br />{itemDiscountPrice}{feeInfo}</>;
  } else {
    return <>{itemPrice}{feeInfo}</>;
  }
}

export function renderSeatInfo(t) {
  const info = [];
  switch(t.ticket_type) {
    case 'VENUE_SEAT': {
      info.push(`Sección: ${t.location.section}`);
      info.push(`Fila: ${t.location.row}`);
      info.push(`Asiento: ${t.location.seat}`);
      break;
    }
    case 'VENUE_TABLE_SEAT': {
      info.push(`Sección: ${t.location.section}`);
      info.push(`Asiento: ${t.location.seat}`);
      break;
    }
    case 'VENUE_OPEN': {
      info.push(`Sección: ${t.location.section}`);
      break;
    }
  }
  return info.join(' / ');
} 